import React from "react";
import ReactDOM from "react-dom/client";
import productDetailInfoService from "./ProductDetailInfoService";
import ProductDetailPageTypeConfig, { ProductDetailInfo } from "./ProductDetailPageTypeConfig";
import ProductPriceRequestModal from "./components/ProductPriceRequestModal";
import elementService from "@/common/ElementService";

export default new class PriceRequestFormService {
    public init(pageTypeConfig: ProductDetailPageTypeConfig): void {
        for (const productPriceRequestContainer of document.querySelectorAll<HTMLDivElement>(".js-product-price-request-container")) {
            ReactDOM.createRoot(productPriceRequestContainer)
                .render(<ProductPriceRequestModal
                    productDetailInfo={this.getProductDetailInfo(pageTypeConfig, productPriceRequestContainer)}
                />);
        }
    }

    private getProductDetailInfo(pageTypeConfig: ProductDetailPageTypeConfig, productPriceRequestContainer: HTMLDivElement): ProductDetailInfo {
        return productDetailInfoService.getProductDetailInfo(
            pageTypeConfig,
            Number.parseInt(elementService.elementData(productPriceRequestContainer, "productId")),
        );
    }
}();
